import {
  EndOfJourneyScanFilter,
  EndOfJourneyScanItem,
  EndOfJourneyScanListResponse
} from '../../lib/types/models/end-of-journey-scan/end-of-journey-scan'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type PageInput = { page?: number; limit?: number }

export function getEndOfJourneyScans(input: PageInput & EndOfJourneyScanFilter) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API['end-of-journey-scans'].getAll.url, null), input))
    .get<EndOfJourneyScanListResponse<EndOfJourneyScanItem>>()
}
